import { css } from "@emotion/css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileCard } from "../../../features/profile/components/profile-card/profile-card";
import { ProfileInfo } from "../../../features/profile/components/profile-info/profile-info";
import { ProfileBalance } from "../../../features/profile/components/profile-balance/profile-balance";
import { ProfilePaymentCards } from "../../../features/profile/components/profile-payment-cards/profile-payment-cards";
import { ProfileOrdersList } from "../../../features/profile/components/profile-orders-list/profile-orders-list";
import { ProfileSubscribedEventsList } from "../../../features/profile/components/profile-subscribed-events-list/profile-subscribed-events-list";
import { useGetProfile } from "../../../features/profile/hooks";
import { useLoading } from "../../../features/loading";
import { useAuth } from "../../../features/auth/hooks/use-auth";

const container = css({
  width: "clamp(0px, 100%, 1440px)",
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: "var(--spacing-xl)",
  "@media (min-width: 96.8rem)": {
    gridTemplateColumns: "300px 1fr",
    gap: "var(--spacing-2xl)",
  },
  "@media (min-width: 102.4rem)": {
    gap: "var(--spacing-3xl)",
  },
});

const sidebar = css({
  width: "100%",
});

const main = css({
  display: "flex",
  flexDirection: "column",
  gap: "var(--spacing-xl)",
});

const loadingContainer = css({
  width: "100%",
  minHeight: "50vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "var(--spacing-md)",
});

const pageTitle = css({
  fontSize: "var(--fs-700)",
  fontWeight: 700,
  color: "var(--secondary-color)",
  marginBottom: "var(--spacing-lg)",
  display: "none",
  "@media (min-width: 96.8rem)": {
    display: "block",
  },
});

export function ProfileIndex() {
  const { data: user, isLoading: isLoadingProfile, isError } = useGetProfile();
  const { setLoading, isLoading } = useLoading();
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(isLoadingProfile);
  }, [isLoadingProfile, setLoading]);

  // Handle profile load error - logout and redirect to login
  useEffect(() => {
    if (isError) {
      console.warn('[ProfileIndex] Error loading profile, logging out user');
      logout();
      navigate('/entrar');
    }
  }, [isError, logout, navigate]);

  // Don't render content while loading
  if (isLoading) {
    return null;
  }

  if (isError || !user) {
    return null;
  }

  return (
    <div className={container}>
      <aside className={sidebar}>
        <ProfileCard user={user} />
      </aside>

      <main className={main}>
        <h1 className={pageTitle}>Minha Conta</h1>
        <ProfileBalance />

        <ProfileInfo profile={user} />

        <ProfilePaymentCards />

        <ProfileOrdersList />

        <ProfileSubscribedEventsList />
      </main>
    </div>
  );
}

export default ProfileIndex;
